import { render, staticRenderFns } from "./skill_link.vue?vue&type=template&id=c1b38bfc&"
import script from "./skill_link.vue?vue&type=script&lang=js&"
export * from "./skill_link.vue?vue&type=script&lang=js&"
import style0 from "./skill_link.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports